import { createFileRoute, notFound } from '@tanstack/react-router';

import { ComponentGallery } from '@/features/dev/ComponentGallery';

/**
 * The kitchen sink, dev builds only: every primitive in every variant on one page, for
 * checking a change against the prototype by eye. Production answers 404.
 */
export const Route = createFileRoute('/dev/components')({
    beforeLoad: () => {
        if (!import.meta.env.DEV) throw notFound();
    },
    component: ComponentGallery,
});
